// extracted by mini-css-extract-plugin
export var phone = "_2z-0";
export var phoneDragging = "_2z-1";